// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.modal-dialog {
  max-width: 600px !important;
}

#striped-light .card {
  margin: 0;
}

form .col-form-label {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}

.table thead th {
  background: transparent;
  color: #586562;
  border-top: none;
}
.table tbody tr:hover {
  background: #e4f1fa;
}`, "",{"version":3,"sources":["webpack://./src/app/commission/modals/commissiondetail.screen.component.scss"],"names":[],"mappings":"AACA;EACC,2BAAA;AAAD;;AAGC;EACC,SAAA;AAAF;;AAGA;EACC,gBAAA;EACG,oBAAA;EACA,sBAAA;AAAJ;;AAIE;EACC,uBAAA;EACA,cAAA;EACA,gBAAA;AADH;AAMG;EACC,mBAAA;AAJJ","sourcesContent":["\ndiv.modal-dialog  {\n\tmax-width:600px !important;\t\n}\n#striped-light {\n\t.card {\n\t\tmargin:0;\n\t}\n}\nform .col-form-label {\n\tfont-weight: 400;\n    text-transform: none;\n    letter-spacing: normal;\n}\n.table {\n\tthead {\n\t\tth {\n\t\t\tbackground: transparent;\n\t\t\tcolor: #586562;\n\t\t\tborder-top: none;\n\t\t}\n\t}\n\ttbody {\n\t\ttr {\n\t\t\t&:hover {\n\t\t\t\tbackground:#e4f1fa;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
